module.exports = __webpack_public_path__ + "img/addressbg.bd0e2ae2.png";